
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sale-event/[eventName]",
      function () {
        return require("private-next-pages/sale-event/[eventName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sale-event/[eventName]"])
      });
    }
  